import refs from '../helpers/refs'

class CInputDate {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
    // Input hover states
    this.$refs.input.addEventListener('focus', () => {
      this.$root.classList.add('active')
    })
    this.$refs.input.addEventListener('blur', () => {
      this.$root.classList.remove('active')
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.a-input-date')
    .forEach(el => new CInputDate(el))
})
